export const convertData = (obj, keysToRemove = [], prefixesToRemove = []) => {
  const removedData = Object.fromEntries(
    Object.entries(obj)
      .filter(([key]) => !keysToRemove.includes(key) && !prefixesToRemove.some(prefix => key.startsWith(prefix)))
      .map(([key, value]) => {
        const dateKeys = ["visad", "userInfo", "internship"];
        const nestedDateKeys = ["issuedOn", "stayFrom", "stayTo", "startDate", "endDate, validUntil"];

        if (typeof value === "string" && dateKeys.includes(key)) {
          value = value.split("T")[0];
        }
        if (typeof value === "object" && value !== null && dateKeys.includes(key)) {
          value = Object.fromEntries(
            Object.entries(value).map(([k, val]) => {
              if (typeof val === "string" && nestedDateKeys.includes(k)) {
                return [k, val.split("T")[0]];
              }
              return [k, val];
            }),
          );
        }
        return [key, value];
      }),
  );

  return removedData;
};
